import { createEvent, createStore, sample } from 'effector';

export const setIsImageCropped = createEvent<boolean>();
export const $isImageCropped = createStore<boolean>(false);

sample({
  clock: setIsImageCropped,
  target: $isImageCropped
});
